export const ageMethod = "age nearest";
export const gateway = "https://standard-api.link.wawanesalife.com";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/standard";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJzdGFuZGFyZCIsIm5hbWUiOiJzdGFuZGFyZCIsImlhdCI6MTc3OTkyNjI3NywiZXhwIjoxOTM3NzE0Mjc3fQ.nQyisoI-oECQrvZPty3v-X5Z7dPud-iE56QAn-Rf3hk";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"standard.link.wawanesalife.com": {
		a: {
			accessibilityLink: "https://www.standardinsurance.ca/accessibility-at-the-standard/",
			approve_company: "CENTRAL",
			approve_user: "link_standard",
			brands: [
				"standard.link.wawanesalife.com",
			],
			broker: "standard",
			broker_formatted_name: "Standard Insurance",
			email: "SFA@standardinsurance.ca",
			environment: "stable",
			environment_id: "stable",
			layout: "modern",
			logoPosition: "menu",
			"maps": {
				"map3": [
					"339 Main Street",
					"Creighton",
					"SK",
					"S0P 0A0",
				],
				"map2": [
					"200-330 St. Mary Avenue",
					"Winnipeg",
					"MB",
					"R3C 2L2",
				],
				"map1": [
					"319 2nd Street S",
					"Kenora",
					"ON",
					"P9N 3X8",
				],
				"map7": [
					"34 Front Street",
					"Sioux Lookout",
					"ON",
					"P8T 1A1",
				],
				"map6": [
					"179 Howey Street",
					"Red Lake",
					"ON",
					"P0V 2M0",
				],
				"map5": [
					"86 Main Street",
					"Flin Flon",
					"MB",
					"R8A 1J8",
				],
				"map4": [
					"73 King Street",
					"Dryden",
					"ON",
					"P8N 1B7",
				],
				"map9": [
					"130 2nd St E",
					"Fort Frances",
					"ON",
					"P9A 1M5",
				],
				"map8": [
					"102-920 Tungsten Street",
					"Thunder Bay",
					"ON",
					"P7B 5Z6",
				],
			},
			menuPhone: "button",
			phone: "1-844-936-3216",
			privacyLink: "https://www.standardinsurance.ca/privacy-policy/",
			website: "https://www.standardinsurance.ca/",
			scope: "standard#branding#standard.link.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "standard.link.wawanesalife.com",
		},
		b: {
			accessibilityLink: "https://www.standardinsurance.ca/accessibility-at-the-standard/",
			approve_company: "CENTRAL",
			approve_user: "link_standard",
			brands: [
				"standard.link.wawanesalife.com",
			],
			broker: "standard",
			broker_formatted_name: "Standard Insurance",
			email: "SFA@standardinsurance.ca",
			environment: "stable",
			environment_id: "stable",
			layout: "modern",
			logoPosition: "menu",
			"maps": {
				"map3": [
					"339 Main Street",
					"Creighton",
					"SK",
					"S0P 0A0",
				],
				"map2": [
					"200-330 St. Mary Avenue",
					"Winnipeg",
					"MB",
					"R3C 2L2",
				],
				"map1": [
					"319 2nd Street S",
					"Kenora",
					"ON",
					"P9N 3X8",
				],
				"map7": [
					"34 Front Street",
					"Sioux Lookout",
					"ON",
					"P8T 1A1",
				],
				"map6": [
					"179 Howey Street",
					"Red Lake",
					"ON",
					"P0V 2M0",
				],
				"map5": [
					"86 Main Street",
					"Flin Flon",
					"MB",
					"R8A 1J8",
				],
				"map4": [
					"73 King Street",
					"Dryden",
					"ON",
					"P8N 1B7",
				],
				"map9": [
					"130 2nd St E",
					"Fort Frances",
					"ON",
					"P9A 1M5",
				],
				"map8": [
					"102-920 Tungsten Street",
					"Thunder Bay",
					"ON",
					"P7B 5Z6",
				],
			},
			menuPhone: "button",
			phone: "1-844-936-3216",
			privacyLink: "https://www.standardinsurance.ca/privacy-policy/",
			website: "https://www.standardinsurance.ca/",
			scope: "standard#branding#standard.link.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "standard.link.wawanesalife.com",
		},
	},
};

//updated on Wed May 27 2026 18:57:57 GMT-0500 (Central Daylight Time)
